<template>
  <iModal
    :visible="visible"
    :max-width="600"
    :show-footer="false"
    title="Edit Publication Logo"
    @close="handleClose"
  >
    <template #body>
      <iRow
        align="between"
        gap="large"
        vertical-align="top"
        width="fill"
        wrap="wrap"
      >
        <iColumn gap="small" width="hug">
          <iText font-size="large">
            Light Mode
          </iText>
          <iImageUploader
            :image="publicationLogo"
            change-image-text="Change Logo"
            select-image-text="Select Logo"
            button-variant="secondary"
            @upload-image="uploadLightLogo"
          />
        </iColumn>

        <iColumn gap="small" width="hug">
          <iText font-size="large">
            Dark Mode
          </iText>
          <iImageUploader
            :image="publicationLogoDark"
            :change-image-text="hasPublicationLogoDark ? 'Change Logo' : 'Upload Logo'"
            select-image-text="Select Logo"
            button-variant="secondary"
            @upload-image="uploadDarkLogo"
          />
        </iColumn>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { LOGO_VARIANT_DARK, LOGO_VARIANT_LIGHT } from "%/constants/publication-constants";

export default {
  name: "EditPublicationLogoModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "publicationLogo",
      "publicationLogoDark",
      "hasPublicationLogoDark",
    ]),
  },
  methods: {
    ...mapActions(useCreatorPublicationStore, [
      "uploadPublicationLogo",
    ]),
    uploadLightLogo(file) {
      this.uploadPublicationLogo(file, LOGO_VARIANT_LIGHT);
    },
    uploadDarkLogo(file) {
      this.uploadPublicationLogo(file, LOGO_VARIANT_DARK);
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
